import BarChart from 'general/components/quybka/Charts/BarChart';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import AgencyReconciliationCardView from '../AgencyReconciliationCardView';

AgencyReconciliationChartView.propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    labels: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.arrayOf(PropTypes.number),
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    valueInfoList: PropTypes.arrayOf(PropTypes.object)
};

function AgencyReconciliationChartView(props) {
    // MARK: ---- PROPERTIES ----
    const {
        title,
        titleColor = AppColors.gray[800],
        labels = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        data = [120, 150, 180, 200, 170, 190, 210, 160, 140, 130],
        color,
        backgroundColor = '#fff',
        valueInfoList,
    } = props;

    return (
        <div
            className="overflow-hidden position-relative"
            style={{
                border: `1px solid ${AppColors.gray[300]}`,
                borderBottom: `5px solid ${color}`,
                borderRadius: '10px',
            }}
        >
            <div
                style={{
                    backgroundColor: '#fff',
                    borderBottomLeftRadius: '10px',
                    borderBottomRightRadius: '10px',
                }}
            >
                {/* barchart */}
                <div className="w-100 d-flex flex-column gap-1 px-4 pt-4 h-300px"
                    style={{
                        borderBottom: `1px solid ${AppColors.gray[300]}`
                    }}
                >
                    <div
                        style={UIHelper.buildFontStyle('700', '14px', titleColor)}

                    >{title}</div>
                    <BarChart
                        title={title}
                        unit=""
                        labels={labels}
                        data={data}
                        color={backgroundColor}
                        hoverColor={color}
                    />
                </div>
                {/* body */}
                <div className="w-100 d-flex">
                    {valueInfoList?.map((valueInfo, index) => (
                        <div
                            key={index}
                            className="flex-grow-1 p-0"
                            style={{ borderRight: index < valueInfoList.length - 1 ? `1px solid ${AppColors.gray[300]}` : 'none' }}
                        >
                            <AgencyReconciliationCardView
                                name={valueInfo.name}
                                value={valueInfo.value}
                                unit={valueInfo.unit}
                                color={valueInfo.color}
                                descriptionValue={valueInfo.descriptionValue}
                                valueFontSize={14}
                                showIcon={false}
                                showBorder={false}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div >
    );
}

export default AgencyReconciliationChartView;